import React from 'react';

import { Grid } from 'e100-react-components';
import Icon from 'components/Icon';
import { FavouriteStationIcon } from 'entities/stations';

import { useShowFavouriteStations, useGetStationByCode } from 'entities/stations';
import { useStyles } from './styles';
import { useStationIcon } from '../../hooks';

export const StationAutoselectOption = ({
  stationCode,
  showIconFavouriteStation = true
}: SearchOptionProps) => {
  const { icon, iconColor } = useStationIcon(stationCode);
  const getStationByCode = useGetStationByCode();
  const { favourite } = getStationByCode(stationCode) || {};
  const classes = useStyles();
  const showFavouriteStations = useShowFavouriteStations();
  return (
    <Grid container alignItems="center">
      <Grid item classes={{ item: classes.iconContainer }}>
        <Icon kind={icon} style={{ color: iconColor }} />
      </Grid>
      <Grid item>
        {stationCode}
      </Grid>
      {
        showFavouriteStations && showIconFavouriteStation && (
          <Grid
            item
            classes={{
              root: classes.favouriteStationsIconContainer
            }}
          >
            <FavouriteStationIcon
              color={favourite ? 'primary' : 'inherit'}
            />
          </Grid>
        )
      }
    </Grid>
  );
};

interface SearchOptionProps {
  stationCode: string;
  showIconFavouriteStation?: boolean;
}